import {useCallback, useState} from 'react';

type UseArrowKeysLoadTriggerHelperReturnType = {
  triggerLoadMore: (
    change: -1 | 1,
    shiftKey: boolean,
    metaKey?: boolean
  ) => void;
  handleLoadFinished: () => void;
};

export const useArrowKeysLoadTriggerHelper = (
  scrollElement: HTMLElement | null | undefined,
  keyDispatchElement: HTMLElement | null
): UseArrowKeysLoadTriggerHelperReturnType => {
  const [keyToTriggerAfterLoading, setKeyToTriggerAfterLoading] = useState<{
    key: 'ArrowUp' | 'ArrowDown';
    shiftKey: boolean;
    metaKey?: boolean;
  }>();

  const triggerLoadMore = useCallback(
    (change: -1 | 1, shiftKey: boolean, metaKey?: boolean) => {
      scrollElement?.scrollBy({
        top: change * 100,
        left: 0,
        behavior: 'smooth',
      });
      setKeyToTriggerAfterLoading({
        key: change > 0 ? 'ArrowDown' : 'ArrowUp',
        shiftKey,
        metaKey,
      });
    },
    [scrollElement]
  );

  const handleLoadFinished = useCallback(() => {
    if (keyToTriggerAfterLoading) {
      keyDispatchElement?.dispatchEvent(
        new KeyboardEvent('keydown', {
          ...keyToTriggerAfterLoading,
          bubbles: true,
        })
      );
      setKeyToTriggerAfterLoading(undefined);
    }
  }, [keyDispatchElement, keyToTriggerAfterLoading]);
  return {handleLoadFinished, triggerLoadMore};
};
